import {
    Flex,
    FlexProps,
    Heading,
} from '@chakra-ui/react';
import React from 'react';

type CateringFormatBlockHeaderProps = {
    formatName: string;
} & FlexProps & React.RefAttributes<HTMLDivElement>

export const CateringFormatMainHeader: React.FC<CateringFormatBlockHeaderProps> = ({
    formatName,
    ...props
}) => (
    <Flex
        flexDirection="row"
        flexWrap="wrap"
        gap="2rem"
        {...props}
    >
        <Heading
            flex={1}
            textDecoration="underline"
        >
            {formatName}
        </Heading>
        {/* <Button
                size="md"
                variant="solid"
                colorScheme="primary"
            >
                УНИВЕРСАЛЬНЫЕ ПРЕДЛОЖЕНИЯ
            </Button> */}
    </Flex>
);
